import {
  Box,
  Button,
  Checkbox,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  VStack,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { actionSignIn, actionSignUp } from "../../api/postApi";
import { waitTime } from "../../utils/waitTime";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash, FaMobileAlt } from "react-icons/fa";
import { RiUser3Fill, RiUserSmileFill } from "react-icons/ri";
import { BiKey, BiTransferAlt } from "react-icons/bi";
import GoogleLoginButton from "./components/googleLogin";
import TelegramLogin from "./components/telegramLogin";
import GoogleLoginV2 from "./components/GoogleLogin_v2";
import CreditPage from "../../utils/credit/credit_page";
import LineLogin from "./components/LineLogin";
import useTransCode from "../../hook/useTransCode";
import useInviteCode from "../../hook/useInviteCode";
import { COMMON_ALT, COMMON_WEB_PATH } from "../../constant";
import useWebsiteInfo from "../../hook/useWebsiteInfo";
import useGames from "../Game/useGames";

const iconStyle = "text-gray-300";

const SigninForm = () => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`header.${key}`, { ...props });
  const i18n_common = (key) => t(`common.${key}`);
  const i18n_common_form = (key) => t(`settings.form.${key}`);
  const i18n_formHint = (key, props) => t(`formHint.${key}`, { ...props });
  const i18n_backend_response = (key) => t(`backend_response.${key}`);

  const toast = useToast();

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { images, is911vipCC } = useWebsiteInfo();

  const [formData, setFormData] = useState({
    user_name: Cookies.get(`${process.env.REACT_APP_WEB_NAME}_account`) || "",
    password: Cookies.get(`${process.env.REACT_APP_WEB_NAME}_password`) || "",
    remember_account:
      Cookies.get(`${process.env.REACT_APP_WEB_NAME}_account`) || false,
  });
  const [buttonLoading, setButtonLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const trans_code = useTransCode();
  const invite_code = useInviteCode();

  const { user_name, password, remember_account } = formData;

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleChecked = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked,
    });
  };

  const handleSeePassword = () => {
    setShowPassword(!showPassword);
  };

  const { previousPage } = useGames({ customPreviousPage: "/" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonLoading(true);

    if (remember_account) {
      Cookies.set(`${process.env.REACT_APP_WEB_NAME}_account`, user_name, {
        expires: 3,
      });
      Cookies.set(`${process.env.REACT_APP_WEB_NAME}_password`, password, {
        expires: 3,
      });
    } else {
      Cookies.remove(`${process.env.REACT_APP_WEB_NAME}_account`);
      Cookies.remove(`${process.env.REACT_APP_WEB_NAME}_password`);
    }

    await actionSignIn({
      account: user_name,
      passwd: password,
      trans_code: trans_code,
    })
      .then((data) => {
        if (Cookies.get("token")) {
          Cookies.remove("token");
        }
        Cookies.set("token", data.token, { expires: 3 });
        Cookies.remove("trans_code");
        dispatch({
          type: "INITIALIZE_API",
          navigate: navigate,
        });

        navigate(previousPage);
      })
      .finally(() => {
        setButtonLoading(false);
      });
  };

  return (
    <form onSubmit={handleSubmit}>
      <VStack spacing={`7px`}>
        <Flex
          flexDirection={"column"}
          justifyContent={`center`}
          alignItems={`center`}
          bgImage={`url(${COMMON_WEB_PATH}/911TW/signinBG.webp)`}
          py="40px"
          px="30px"
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100% 100%"
          w="100%"
        >
          <Image src={images.accountTitle} width={"auto"} alt={COMMON_ALT} />
          <FormControl isRequired mb={`10px`}>
            {/* <FormLabel>{i18n_common_form("account")}</FormLabel> */}
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <RiUser3Fill className={iconStyle} />
              </InputLeftElement>
              <Input
                type="text"
                variant={`brandPrimary`}
                name="user_name"
                value={user_name}
                onChange={handleInputChange}
                placeholder={`${i18n_common("pleaseInput")} ${i18n_common_form(
                  "account",
                )}`}
              />
            </InputGroup>
          </FormControl>
          <Image src={images.passwordTitle} width={"auto"} alt={COMMON_ALT} />
          <FormControl isRequired mb={`10px`}>
            {/* <FormLabel>{i18n_common_form("password")}</FormLabel> */}
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <BiKey className={iconStyle} />
              </InputLeftElement>
              <Input
                type={showPassword ? "text" : "password"}
                variant={`brandPrimary`}
                name="password"
                value={password}
                onChange={handleInputChange}
                placeholder={`${i18n_common("pleaseInput")} ${i18n_common_form(
                  "password",
                )}`}
              />
              <InputRightElement>
                {showPassword ? (
                  <FaEyeSlash
                    className="cursor-pointer"
                    onClick={handleSeePassword}
                  />
                ) : (
                  <FaEye
                    className="cursor-pointer"
                    onClick={handleSeePassword}
                  />
                )}
              </InputRightElement>
            </InputGroup>
          </FormControl>
          {trans_code && (
            <FormControl isRequired>
              <FormLabel>{i18n_common_form("轉移代碼")}</FormLabel>
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <BiTransferAlt className={iconStyle} />
                </InputLeftElement>
                <Input
                  type={"text"}
                  variant={`brandPrimary`}
                  name="trans_code"
                  value={trans_code}
                  isDisabled={true}
                />
              </InputGroup>
            </FormControl>
          )}
          <Flex>
            <Checkbox
              isChecked={remember_account}
              name="remember_account"
              onChange={handleChecked}
              color={"#e495ff"}
            >
              {i18n_common("記住帳密")}
            </Checkbox>
          </Flex>
        </Flex>
        {/* <Divider my="10px" /> */}
        <Flex
          direction="column"
          gap="15px"
          w="100%"
          alignItems="center"
          justifyContent="center"
        >
          <Button
            // variant={`brandPrimary`}
            isLoading={buttonLoading}
            disabled={buttonLoading}
            // py="40px"
            type="submit"
            w="260px"
            h="55px"
            bgImage={`url('${images.signinBTN}')`}
            bgPosition="center"
            bgRepeat="no-repeat"
            bgSize="100% 100%"
            _hover={{
              filter: "brightness(1.1)",
            }}
          >
            {/* {i18n("signin")} */}
          </Button>
          {/* <GoogleLoginButton
            setButtonLoading={setButtonLoading}
            buttonLoading={buttonLoading}
          /> */}
          {/* <CreditPage>
            <GoogleLoginV2 />
            <TelegramLogin
              setButtonLoading={setButtonLoading}
              buttonLoading={buttonLoading}
            />
          </CreditPage> */}
          {!is911vipCC && (
            <LineLogin
              setButtonLoading={setButtonLoading}
              buttonLoading={buttonLoading}
            />
          )}
        </Flex>
      </VStack>
    </form>
  );
};

export default SigninForm;
